import { Reveal } from "./Reveal";
import { BookOpen, FileText, Presentation, Award } from "lucide-react";

const STATS = [
  { n: "2", label: "Authored Books" },
  { n: "5+", label: "Presentations" },
  { n: "IPS", label: "Life Member" },
  { n: "BLS", label: "AHA Certified" },
];

const GROUPS = [
  {
    icon: FileText,
    title: "Publication",
    items: [
      "Mishra PH et al. — Custom Healing Abutments: A Practical Approach for Deep Subgingival Implants. Asian Journal of Oral Health & Allied Science, 2025.",
    ],
  },
  {
    icon: BookOpen,
    title: "Authored Books",
    items: [
      "Clinical Anatomy of Facial Aesthetics — Book Rivers, 2025.",
      "Gingival Retraction: Digital vs Conventional Workflow — Updent Publication, 2024.",
    ],
  },
  {
    icon: Presentation,
    title: "Selected Presentations",
    items: [
      "AI-Driven vs Clinician-Guided Dental Implantology — IPS UP State Conference, 2025.",
      "Obstructive Sleep Apnea — IPS PG Convention, 2024.",
      "Emerging Trends in OSA — Sleep Apnea National Symposium, 2025.",
      "Ocular & Auricular Prosthesis — IPS PG Convention / KGMU Lucknow, 2023–24.",
    ],
  },
  {
    icon: Award,
    title: "Affiliations",
    items: [
      "Life Member — Indian Prosthodontic Society (IPS).",
      "Basic Life Support (BLS) — AHA Certified, 2023.",
    ],
  },
];

export const Recognition = () => {
  return (
    <section
      id="recognition"
      data-testid="recognition-section"
      className="bg-emerald grain-overlay py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Heading + stats */}
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-champagne text-xs uppercase tracking-[0.3em] mb-6">
                Recognition & Scholarship
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-ivory leading-[1.05]">
                Research, writing &amp; peer recognition.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-ivory/60 leading-relaxed max-w-md">
                Beyond the clinic, Dr. Mishra contributes to the profession through published
                research, authored texts and presentations at national prosthodontic forums.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-12 grid grid-cols-2 gap-px bg-ivory/10 border border-ivory/10">
                {STATS.map((s) => (
                  <div key={s.label} className="bg-emerald p-6" data-testid={`stat-${s.label}`}>
                    <p className="font-display text-3xl md:text-4xl text-champagne">{s.n}</p>
                    <p className="text-ivory/60 text-xs uppercase tracking-[0.18em] mt-2">
                      {s.label}
                    </p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          {/* Groups */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-10">
            {GROUPS.map((g, i) => (
              <Reveal key={g.title} delay={0.1 + i * 0.06}>
                <div className="border-t border-champagne/25 pt-6">
                  <div className="flex items-center gap-3 mb-5">
                    <g.icon className="text-champagne" size={18} />
                    <h3 className="text-ivory font-display text-xl tracking-tight">{g.title}</h3>
                  </div>
                  <ul className="space-y-4">
                    {g.items.map((it, j) => (
                      <li key={j} className="flex gap-3 text-ivory/70 text-sm leading-relaxed">
                        <span className="mt-2 h-px w-4 bg-champagne/60 shrink-0" />
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Recognition;
